import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  dropdown: {
    width: "100%",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
  },
  field: {
    width: "100%",
  },
});
